import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMostOptions = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "mostOptions",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	enableBackground: "new 0 0 24 24",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12437",
			fill: "none",
			d: "M0,0h24v24H0V0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12438",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M21,12 h-3.6c-0.8,0-1.4,0.6-1.4,1.4l0,0v1.2c0,0.8,0.6,1.4,1.4,1.4c0,0,0,0,0,0H21"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12439",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M19,21H5 c-1.1,0-2-0.9-2-2V9c0-1.1,0.9-2,2-2h14c1.1,0,2,0.9,2,2v10C21,20.1,20.1,21,19,21z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12440",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M14,7 l-3.3-3.3c-0.4-0.4-1-0.4-1.4,0L6,7"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12441",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M12,5 l1.3-1.3c0.4-0.4,1-0.4,1.4,0L18,7"
		})
	]
});
export default SvgMostOptions;
